// extracted by mini-css-extract-plugin
export default {"productDescription":"Zba-z","featuredDescription":"_ba-z","description":"aca-z","more":"bca-z","descriptionSku":"cca-z"};